import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { CancellationReasonsQuery } from '../../queries/cancellation_reasons_query';
import { AppointmentInfoServant } from '../../servants/appointment_info_servant';
import { AppointmentRemindersServant } from '../../servants/appointment_reminders_servant';
import {
  IAppointment,
  IAppointmentCancellationForm,
  IAppointmentCancellationReason,
  IAppointmentCard,
  IAppointmentDetails
} from '../../types/appointment_interfaces';

export class AppointmentCard extends AppointmentInfoServant {
  appointment: IAppointment;
  card: IAppointmentCard;
  appointmentDetails: IAppointmentDetails;
  isPastAppointment: boolean;
  isCancelButtonDisabled: boolean;
  isAppointmentCancelled: boolean;
  showCancelButton: boolean;
  cancelButtonCallback: () => void;
  constructor(private $scope: ng.IScope, private accountModel: AccountModel, private $attrs: ng.IAttributes) {
    super();
  }
  $onInit(): void {
    this.initilize();
    this.showCancelButton = !_4.isNil(this.$attrs.cancelButtonCallback);
  }
  $onChanges(): void {
    this.initilize();
  }
  initilize(): void {
    this.isPastAppointment = !!this.isPastAppointment;
    this.card = this.generateCardInfo(this.appointment);
    this.appointmentDetails = this.generateAppointmentDetails(this.appointment, this.accountModel.fullname);
    this.isCancelButtonDisabled =
      this.isPastAppointment || !this.appointment.student_can_cancel || this.card.isCancelled;
    this.isAppointmentCancelled = false;
  }
  isCancelEnabled(): boolean {
    return !this.appointment.is_cancelled && this.showCancelButton;
  }
  isCancelDisabled(): boolean {
    return !this.appointment.student_can_cancel;
  }
  openCancelForm(): void {
    this.cancelButtonCallback();
  }
}

angular.module('capability-ng-appointments').component('appointmentCard', {
  bindings: {
    appointment: '<',
    isPastAppointment: '<',
    cancelButtonCallback: '&'
  },
  controller: AppointmentCard,
  templateUrl: 'capability-ng-appointments/src/components/appointment_card/appointment_card.html'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/components/appointment_card/appointment_card.ts